import { IRole } from "@/models";

import { BaseRepository } from "@/repositories";

class RoleRepository extends BaseRepository<IRole> {
    constructor() {
        super("/roles");
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    public async getUnautorizeRoles(parameters?: any): Promise<IRole[]> {
        return await this.get<IRole[]>("/GetUnauthorizeRoles", parameters);
    }
}

const roleRepository = new RoleRepository();

export { RoleRepository, roleRepository };
